import { createContext, useContext, useState } from 'react';
import { useSelector } from 'react-redux';
import { selectPersonId } from '../../redux/selectors/userDataSelectors';

export const ORDERS_VIEW = 'orders';
export const VEHICLE_VIEW = 'vehicle';
const DEFAULT_VIEW = ORDERS_VIEW;

const getKey = personId => `USER_VIEW_ORDERS_PREFERENCES_${personId}`;

export const ViewOrderOrVehicleContext = createContext({
  view: ORDERS_VIEW,
  setView: newView => {},
});

export const ViewOrderOrVehicleProvider = ({ children }) => {
  const personId = useSelector(selectPersonId);
  const [view, _setView] = useState(
    localStorage.getItem(getKey(personId)) || DEFAULT_VIEW
  );

  const setView = newView => {
    _setView(newView);
    localStorage.setItem(getKey(personId), newView);
  };

  return (
    <ViewOrderOrVehicleContext.Provider value={{ view, setView }}>
      {children}
    </ViewOrderOrVehicleContext.Provider>
  );
};

export const useViewOrdersOrVehicle = () => {
  const { view, setView } = useContext(ViewOrderOrVehicleContext);

  return { view, setView };
};
